import React from 'react';

/**
 * @deprecated this does not support useRef and is being moved into a new package.
 * Use @atlassian/jira-feature-flagging-utils and componentWithCondition instead.
 */

const componentWithCondition = <P,>(
	conditionGetter: () => boolean,
	ComponentTrue: Flow.AbstractComponent<P>,
	ComponentFalse: Flow.AbstractComponent<P>,
): Flow.AbstractComponent<P> => {
	const ComponentWithCondition = (props: P) =>
		// @ts-expect-error - TS2322 - Type 'P' is not assignable to type 'IntrinsicAttributes & PropsWithoutRef<P> & RefAttributes<any> & { children?: ReactNode; }'. | TS2322 - Type 'P' is not assignable to type 'IntrinsicAttributes & PropsWithoutRef<P> & RefAttributes<any> & { children?: ReactNode; }'.
		conditionGetter() ? <ComponentTrue {...props} /> : <ComponentFalse {...props} />;
	if (conditionGetter.name !== '') {
		ComponentWithCondition.displayName = `ComponentWithCondition[${conditionGetter.name}]`;
	}
	// @ts-expect-error - TS2322 - Type '{ (props: P): JSX.Element; displayName: string; }' is not assignable to type 'AbstractComponent<P, any>'.
	return ComponentWithCondition;
};

export default componentWithCondition;
